import React from "react";
import Navebar from "../Navebar/Navebar";
import About from "../Page/About";
import Contucts from "../Page/Contucts";
import Footer from "../Page/Footer";
import Hero from "../Page/Hero";
import Project from "../Page/Project";
import Skills from "../Page/Skills";

const Home = () => {
  return (
    <div>
      <Navebar />

      <div>
        <Hero />
      </div>

      <div
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
        id="About"
        className="mt-5"
      >
        <h1 className=" text-3xl font-bold text-center text-blue-400">
          About Myself
        </h1>
        <div className=" text-3xl font-bold text-center text-red-400">
          <p>...........................</p>
        </div>
        <About />
      </div>

      <div
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
      >
        <h1 className="mt-6  text-3xl font-bold text-center text-blue-400">
          My Skills
        </h1>
        <div className="mb-14 text-3xl font-bold text-center text-red-400">
          <p>...........................</p>
        </div>
        <Skills />
      </div>

      <div
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
        id="Projects"
        className="mt-28"
      >
        <h1 className="mt-6  text-3xl font-bold text-center text-blue-400">
          My Recent Projects
        </h1>
        <div className="mb-14 text-3xl font-bold text-center text-red-400">
          <p>...........................</p>
        </div>
        <Project />
      </div>

      <div
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
        id="contucts"
        className="mt-14"
      >
        <h1 className="mt-6  text-3xl font-bold text-center text-blue-400">
          Contact Me
        </h1>
        <div className="mb-9 text-3xl font-bold text-center text-red-400">
          <p>...........................</p>
        </div>
        <Contucts />
      </div>

      <div className="mt-20">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Home;
